import type { SCFormFieldProps } from './form_field';
import { FormText } from 'eone-ui/forms/form-text';
import { handleFieldUp } from './helper';
import { SCFormField } from './form_field';
import './styles.css';

//interface SCFormFieldTextProps extends Partial<React.ComponentProps<typeof FormText>> {}

const SCFormFieldText = ({
  label,
  name,
  required,
  disabled,
  rules,
  ...rest
}: Partial<React.ComponentProps<typeof FormText>> & SCFormFieldProps) => {
  return (
    <SCFormField label={label} name={name} disabled={disabled} required={required} rules={rules}>
      {({ field, extraProps }) => {
        return (
          <FormText
            {...handleFieldUp(field, { disabledRef: true, defaultValue: '' })}
            Label={label}
            Required={required}
            // ShowRequiredIndicator={required}
            {...rest}
            {...extraProps}
          />
        );
      }}
    </SCFormField>
  );
};

export { SCFormFieldText };
//export type { SCFormFieldTextProps };
